// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\CoordinationCard\ApiCoordinationCard.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { Change, ChangeData, ChangeOptions } from 'data/models/Change';
import { Coordination, CoordinationData, CoordinationOptions } from 'data/models/Coordination';
import { CoordinationCardSelf, CoordinationCardSelfData, CoordinationCardSelfOptions } from 'data/models/CoordinationCardSelf';
import { CoordinationCardStatus, CoordinationCardStatusData, CoordinationCardStatusOptions } from 'data/models/CoordinationCardStatus';
import { CoordinationCardVersion, CoordinationCardVersionData, CoordinationCardVersionOptions } from 'data/models/CoordinationCardVersion';
import { CoordinationProvider, CoordinationProviderData, CoordinationProviderOptions } from 'data/models/CoordinationProvider';
import { ScheduleDateEntity, ScheduleDateEntityData, ScheduleDateEntityOptions } from 'data/models/ScheduleDateEntity';

// CoordinationCardData is the class that CoordinationCard serializes to/from
export interface CoordinationCardData {
    Id : number;
    Url : string | null;
	
    Change : ChangeData | null;
    ChangeId : number;
    Coordination : CoordinationData | null;
    CoordinationId : number;
    Provider : CoordinationProviderData | null;
    ProviderId : number;
    ScheduleDate : ScheduleDateEntityData | null;
    ScheduleDateId : number;
    Self : CoordinationCardSelfData | null;
    Status : CoordinationCardStatusData | null;
    StatusId : number;
    Version : CoordinationCardVersionData | null;
	
    StatusReason : string | null;
}

// CoordinationCardOptions is the class which may be passed to the CoordinationCard constructor to define optional initial data values
export interface CoordinationCardOptions {
    Id : number;
    Url? : string | null;
	
    Change? : ChangeOptions | null;
    ChangeId? : number;
    Coordination? : CoordinationOptions | null;
    CoordinationId? : number;
    Provider? : CoordinationProviderOptions | null;
    ProviderId? : number;
    ScheduleDate? : ScheduleDateEntityOptions | null;
    ScheduleDateId? : number;
    Self? : CoordinationCardSelfOptions | null;
    Status? : CoordinationCardStatusOptions | null;
    StatusId? : number;
    Version? : CoordinationCardVersionOptions | null;
	
    StatusReason? : string | null;
}

export class CoordinationCard {
    public Id : DataSignal<number>;
    public Url : DataSignal<string | null>;
	
    public Change : DataSignal<Change | null>;
    public ChangeId : DataSignal<number>;
    public Coordination : DataSignal<Coordination | null>;
    public CoordinationId : DataSignal<number>;
    public Provider : DataSignal<CoordinationProvider | null>;
    public ProviderId : DataSignal<number>;
    public ScheduleDate : DataSignal<ScheduleDateEntity | null>;
    public ScheduleDateId : DataSignal<number>;
    public Self : DataSignal<CoordinationCardSelf | null>;
    public Status : DataSignal<CoordinationCardStatus | null>;
    public StatusId : DataSignal<number>;
    public Version : DataSignal<CoordinationCardVersion | null>;
	
    public StatusReason : DataSignal<string | null>;

    constructor();
    constructor(data : CoordinationCardOptions);
    constructor(data: CoordinationCardOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
        this.Url = jsonableObservable(S.value<string | null>(data && data.Url !== undefined ? data.Url : null));
	    
        this.Change = S.value<Change | null>(null);
        this.ChangeId = jsonableObservable(S.value<number>(data && data.ChangeId !== undefined ? data.ChangeId : 0));
        this.Coordination = S.value<Coordination | null>(null);
        this.CoordinationId = jsonableObservable(S.value<number>(data && data.CoordinationId !== undefined ? data.CoordinationId : 0));
        this.Provider = S.value<CoordinationProvider | null>(null);
        this.ProviderId = jsonableObservable(S.value<number>(data && data.ProviderId !== undefined ? data.ProviderId : 0));
        this.ScheduleDate = S.value<ScheduleDateEntity | null>(null);
        this.ScheduleDateId = jsonableObservable(S.value<number>(data && data.ScheduleDateId !== undefined ? data.ScheduleDateId : 0));
        this.Self = S.value<CoordinationCardSelf | null>(null);
        this.Status = S.value<CoordinationCardStatus | null>(null);
        this.StatusId = jsonableObservable(S.value<number>(data && data.StatusId !== undefined ? data.StatusId : 0));
        this.Version = S.value<CoordinationCardVersion | null>(null);
	    
        this.StatusReason = jsonableObservable(S.value<string | null>(data && data.StatusReason !== undefined ? data.StatusReason : null));
    }

    static key(obj : CoordinationCard) {
        return obj.Id();
    }
    
    static dataKey(obj : CoordinationCardOptions) {
        return obj.Id;
    }

    static update(obj : CoordinationCard, data : CoordinationCardOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
            if (data.Url !== undefined) obj.Url(data.Url);
	        
            if (data.ChangeId !== undefined) obj.ChangeId(data.ChangeId);
            if (data.CoordinationId !== undefined) obj.CoordinationId(data.CoordinationId);
            if (data.ProviderId !== undefined) obj.ProviderId(data.ProviderId);
            if (data.ScheduleDateId !== undefined) obj.ScheduleDateId(data.ScheduleDateId);
            if (data.StatusId !== undefined) obj.StatusId(data.StatusId);
	        
            if (data.StatusReason !== undefined) obj.StatusReason(data.StatusReason);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/CoordinationCard.ts